<template>
  <div>
    <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
      <ux-table-column align="center" type="checkbox" width="80" :visible='true' />
      <ux-table-column align="center" title="报告维护频率" field="reportFreqDesc" width="100" :visible='true' />
      <ux-table-column align="center" title="报告期限" min-width="100" field="reportDate" :visible='true'>
        <template v-slot="scope">
          <el-button type="text" @click="goDetail(scope.row)">{{
            scope.row.reportDate
          }}</el-button>
        </template>
      </ux-table-column>
      <ux-table-column align="center" title="Category3" field="category3Name" width="100" :visible='true' />
      <ux-table-column align="center" title="Sponsor" min-width="100" field="sponsorName" :visible='true'></ux-table-column>
      <ux-table-column align="center" title="ASL Group" min-width="120" field="aslGroupName" :visible='true'></ux-table-column>
      <ux-table-column align="center" title="麦当劳农场出栏量(只)" min-width="160" field="mcdFarmCrapAmount" :visible='true'></ux-table-column>
      <ux-table-column align="center" title="麦当劳农场出栏量(重量,kg)" min-width="190" field="mcdFarmCrapWeight" :visible='true'></ux-table-column>
      <ux-table-column align="center" title="抗生素用量(mg/kg)(原粉量/出栏总重量)" min-width="280" field="antibioticsUsage" :visible='true'></ux-table-column>
      <ux-table-column align="center" title="HPCIA类抗生素使用量(mg/kg)(HPCIA抗生素原粉量/出栏总重量)" min-width="460" field="hpciaAntibioticsUsage" :visible='true'></ux-table-column>
      <ux-table-column align="center" title="前7日抗生素使用量（mg/kg)" min-width="200" field="usageIn7Day" :visible="showStatus"></ux-table-column>
      <ux-table-column align="center" title="状态" min-width="80" field="statusI18n" :visible='true'></ux-table-column>
      <ux-table-column align="center" title="更新人" min-width="100" field="submitUser" :visible='true'></ux-table-column>
      <ux-table-column align="center" title="更新日期" min-width="120" field="submitDate" :visible='true'></ux-table-column>
    </ux-grid>
  </div>
</template>
<script>
export default {
  name: "McdSrmVueCommonTable",
  props: ["data", "total", "showStatus"],
  watch: {
    data: {
      handler(newV) {
        console.log("GY🚀 ~ file: commonTable.vue:35 ~ handler ~ newV:", newV);
        if (newV) {
          this.tableData = newV;
        }
      },
      deep: true,
      immediate: true,
    },
    showStatus: {
      handler(newV) {
        console.log("GY🚀 ~ handler ~ newV:", newV);
        
      },
      immediate: true,
    },
  },
  data() {
    return {
      multipleSelection: [],
      tableData: [],
      pageObj: {
        pageNum: 1,
        pageSize: 15,
        totalCount: 0,
      },
    };
  },

  mounted() {
    console.log("showStatus", this.showStatus);
  },

  methods: {
    selectionChange(val) {
      this.$emit("selectionChange", val);
    },
    goDetail(row) {
      this.$emit("goToDetail", row.ttRmcProteinMedicineUsageId, row.reportFreq);
    },
  },
};
</script>
